module.exports = __webpack_public_path__ + "426c0d64597047ce596fa5bf50a25d98.svg";